export default [
    {
        path: "reports",
        name: "monitoring-reports",
        redirect: { name: "monitoring-reports-monthly" },
        component: () => import("@/views/monitoring/views/reports/Reports.vue"),
        meta: {
            section: 12,
            pageTitle: "Reports",
            breadcrumb: [
                {
                    text: "Monthly",
                },
            ],
            tabs: [
                {
                    title: "Monthly",
                    name: "monitoring-reports-monthly",
                },
                {
                    title: "Details",
                    name: "monitoring-reports-details",
                },
                {
                    title: "Year",
                    name: "monitoring-reports-year",
                },
            ],
        },
        children: [
            {
                path: "Monthly",
                name: "monitoring-reports-monthly",
                component: () =>
                    import(
              /* webpackChunkName: "MonitoringReportsMonthly" */ "@/views/monitoring/views/reports/components/ReportsTab.vue"
                    ),
                meta: {
                    section: 12,
                    tab: 1,
                    pageTitle: "Reports",
                    breadcrumb: [
                        {
                            text: "Monthly",
                            active: true
                        },
                    ],
                },
            },
            {
                path: "details",
                name: "monitoring-reports-details",
                component: () =>
                    import(
              /* webpackChunkName: "MonitoringReportsDetails" */ "@/views/monitoring/views/reports/components/ReportsTab.vue"
                    ),
                meta: {
                    section: 12,
                    tab: 2,
                    pageTitle: "Reports",
                    breadcrumb: [
                        {
                            text: "Details",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "year",
                name: "monitoring-reports-year",
                component: () =>
                    import(
              /* webpackChunkName: "MonitoringReportsDetails" */ "@/views/monitoring/views/reports/components/year/YearReportsTab.vue"
                    ),
                meta: {
                    section: 12,
                    tab: 3,
                    pageTitle: "Reports",
                    breadcrumb: [
                        {
                            text: "Year",
                            active: true,
                        },
                    ],
                },
            },
        ],
    },
];
